import { useEffect } from "react";

const SITE_URL = "https://hariomtrading.co.in";

export default function SEO({ title, description, jsonLd, noindex }) {
  const jsonKey = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    const path = window.location.pathname === "/" ? "/" : window.location.pathname.replace(/\/+$/, "");
    canonical.setAttribute("href", `${SITE_URL}${path}`);
    let robots = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.name = "robots";
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex, nofollow");
    } else if (robots) {
      robots.remove();
    }
    let script;
    if (jsonLd) {
      const nodes = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seoInjected = "page";
      script.text = JSON.stringify(nodes.length === 1 ? nodes[0] : nodes);
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, jsonKey, noindex]);
  return null;
}
